<template>
	<div class="no-result" :class="border">
    <div class="inner">
      <i class="no-result-icon"/>
      <p class="no-result-text" v-html="message"></p>
    </div>
	</div>
</template>

<script>
export default {
	props:{
		message:{
			type: String
		},
    border: { //use-border
      type: String
    }
	},
	data() {
		return {

    }
	}
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
